var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('questions-table',{attrs:{"show-relations":true,"show-add-button":false,"media-options":_vm.mediaOptions,"useEditModel":false},on:{"row:view":_vm.view}})}
var staticRenderFns = []

export { render, staticRenderFns }